import React, { useState, useEffect, useCallback } from "react";
import Socket from "socket";
import { debounce } from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  bounce_right_to_left_variants_delay,
  bounce_right_to_left_variants_without_children
} from "shared/components/animations";
import roundOver from "assets/images/tot/round-over.png";
import tick from "assets/images/tot/score-tick.png";

const TOTResultRound = ({ joke, word, roomId, isGuesser }) => {
  const [counter, setCounter] = useState(10);

  const updateStatusAction = () => {
    const data = {
      roomId: roomId,
      action: "update-status"
    };
    Socket.sendMessage(data);
  };

  const handleUpdateStatus = useCallback(
    debounce((type) => updateStatusAction(type), 1000, {
      leading: true,
      trailing: false
    }),
    [roomId]
  );

  useEffect(() => {
    let timer;
    timer =
      counter > 0 && setInterval(() => setCounter((prev) => prev - 1), 1000);
    counter === 0 && handleUpdateStatus();
    return () => clearInterval(timer);
  }, [counter]);

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="tot-result-round"
    >
      <motion.img
        variants={bounce_right_to_left_variants_without_children}
        alt=""
        src={roundOver}
      />
      <motion.span variants={bounce_right_to_left_variants_delay}>
        Last Word:
      </motion.span>
      <motion.h2 variants={bounce_right_to_left_variants_delay}>
        {word}
      </motion.h2>
      {isGuesser ? (
        <button className="tot-ok-btn" onClick={handleUpdateStatus}>
          <img alt="" src={tick} />
          <p>OK ({counter})</p>
        </button>
      ) : (
        <div className="clue-giver-div">
          <span>Did you know?</span>
          <p>
            {joke !== ""
              ? joke
              : `"Patience is not an ability to wait, but the ability to keep a good
            attitude while waiting." -Annoying Person`}
          </p>
        </div>
      )}
    </motion.div>
  );
};

export default TOTResultRound;
